// extracted by mini-css-extract-plugin
export default {"RecipientsCategoryPicker":"_RecipientsCategoryPicker--gwP06","PrivateTag":"_PrivateTag--S1X2F"};